<div
  class="chart-notification-container"
  *ngIf="!selected && isToggleActive && !comingSoon && !isLoading"
>
  <p class="pick-area">
    <app-icon svgIcon="clickArea" class="pick-area-icon"></app-icon>
    <span>
      Click an area on the map to see the chart, or
      <button type="button" class="link-button" (click)="searchAddress()">
        search an address
      </button>
    </span>
  </p>
</div>

<div
  class="chart-notification-container"
  *ngIf="
    selected &&
    isToggleActive &&
    !containsInfo &&
    !comingSoon &&
    !isLoading &&
    (!selectedYear || noAccessibleYears)
  "
>
  <p>This area doesn't have enough data to generate a chart.</p>
</div>

<div
  class="chart-notification-container"
  *ngIf="
    selected &&
    isToggleActive &&
    !containsInfo &&
    !comingSoon &&
    !isLoading &&
    selectedYear &&
    !noAccessibleYears
  "
>
  <p>
    Not enough data for {{ selectedYear }} to generate this chart. Try another
    year.
  </p>
</div>

<div class="chart-notification-container" *ngIf="comingSoon && isToggleActive">
  <p>{{ customText }}</p>
</div>
